<template>
  <!-- , width: fixedHeader ? `calc(100% - ${sidebarOpened ? 256 : 80}px)` : '100%'  -->
  <a-layout-header
    v-if="!headerBarFixed"
    :class="[
      fixedHeader && 'ant-header-fixedHeader',
      sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed',
    ]"
    :style="{ padding: '0' }"
  >
    <div v-if="mode === 'sidemenu'" class="header" :class="theme">
      <a-icon
        v-if="device === 'mobile'"
        class="trigger"
        :type="collapsed ? 'menu-fold' : 'menu-unfold'"
        @click="toggle"
      ></a-icon>
      <a-icon v-else class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="toggle" />

      <!-- <span v-if="device === 'desktop'">欢迎进入 楷码集团信息系统</span>
      <span v-else>楷码集团信息系统</span>-->

      <user-menu :theme="theme" />
    </div>
    <!-- 顶部导航栏模式 -->
    <div v-else :class="['top-nav-header-index', theme]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:svgjs="http://svgjs.com/svgjs"
        width="1280"
        height="51"
        preserveAspectRatio="none"
        viewBox="0 0 1280 51"
        v-if="theme == 'dark' && false"
      >
        <g mask='url("#SvgjsMask2019")' fill="none">
          <rect width="1280" height="51" x="0" y="0" fill="transparent"></rect>
          <path
            d="M43.72089123433251 14.108722002328246L48.048891833273245 2.8338949700395304 36.774064800984526-1.4941056289012007 32.4460642020438 9.780721403387515z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float1"
          ></path>
          <path
            d="M47.903,38.405C49.476,38.403,50.737,37.221,51.473,35.831C52.158,34.536,52.19,32.986,51.434,31.731C50.701,30.515,49.323,29.89,47.903,29.907C46.514,29.924,45.234,30.625,44.515,31.813C43.769,33.046,43.654,34.56,44.313,35.842C45.033,37.244,46.327,38.407,47.903,38.405"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float2"
          ></path>
          <path
            d="M88.01686534738008 35.81093280829909L78.29044552151481 36.1505868730181 78.63009958623381 45.87700669888337 88.35651941209909 45.537352634164364z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float3"
          ></path>
          <path
            d="M156.308317967412 20.611882535611215L148.40566748430209 10.124711134924178 137.91849608361505 18.027361618034085 145.82114656672496 28.514533018721124z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float4"
          ></path>
          <path
            d="M175.426,65.876C180.921,65.887,185.986,62.659,188.497,57.771C190.822,53.245,189.365,48.051,186.857,43.624C184.303,39.114,180.603,34.938,175.426,34.693C169.878,34.43,164.677,37.605,161.949,42.443C159.267,47.2,159.72,52.986,162.443,57.72C165.174,62.469,169.948,65.865,175.426,65.876"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float2"
          ></path>
          <path
            d="M182.538,3.371C184.299,3.38,185.972,2.52,186.856,0.997C187.743,-0.531,187.589,-2.375,186.784,-3.948C185.889,-5.697,184.5,-7.332,182.538,-7.445C180.408,-7.568,178.307,-6.399,177.345,-4.494C176.454,-2.73,177.204,-0.695,178.293,0.954C179.254,2.41,180.793,3.362,182.538,3.371"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float2"
          ></path>
          <path
            d="M262.23160066908565 19.585956977587642L272.52803993410964 15.001686860261813 267.94376981678386 4.705247595237804 257.6473305517598 9.289517712563633z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float3"
          ></path>
          <path
            d="M345.027,65.088C349.672,64.706,352.483,60.328,354.517,56.134C356.247,52.568,356.457,48.619,354.753,45.04C352.735,40.802,349.713,36.483,345.027,36.208C339.992,35.913,335.64,39.411,333.105,43.772C330.555,48.159,329.907,53.527,332.384,57.955C334.916,62.481,339.858,65.513,345.027,65.088"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float4"
          ></path>
          <path
            d="M470.77343412819533 26.447287300053894L475.6113554608227 40.541250632445276 484.32743630945924 30.861062161686508z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float1"
          ></path>
          <path
            d="M557.196,47.644C558.557,47.593,559.823,46.941,560.515,45.768C561.219,44.575,561.29,43.087,560.589,41.893C559.896,40.712,558.565,40.113,557.196,40.115C555.83,40.117,554.551,40.748,553.816,41.9C553.018,43.15,552.668,44.754,553.42,46.032C554.164,47.296,555.73,47.698,557.196,47.644"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float2"
          ></path>
          <path
            d="M631.143,17.356C633.458,17.442,635.704,16.398,636.933,14.434C638.239,12.346,638.503,9.686,637.279,7.549C636.048,5.401,633.619,4.337,631.143,4.326C628.647,4.315,626.075,5.286,624.916,7.496C623.816,9.594,624.789,12.026,626.054,14.029C627.214,15.865,628.973,17.275,631.143,17.356"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float3"
          ></path>
          <path
            d="M678.7361791503604 8.410004518321873L688.2583155564213 11.688739020439455 691.5370500585389 2.16660261437854 682.014913652478-1.1121318877390411z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float4"
          ></path>
          <path
            d="M724.984,42.243C729.894,41.858,733.06,37.648,735.566,33.408C738.135,29.061,740.736,24.03,738.389,19.559C735.929,14.872,730.267,12.92,724.984,13.249C720.232,13.545,716.73,17.04,714.193,21.068C711.414,25.481,708.709,30.682,711.077,35.328C713.597,40.272,719.452,42.677,724.984,42.243"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float4"
          ></path>
          <path
            d="M858.229,41.464C859.639,41.434,860.848,40.531,861.527,39.295C862.181,38.106,862.139,36.699,861.51,35.497C860.826,34.19,859.703,33.044,858.229,32.99C856.676,32.933,855.255,33.879,854.506,35.241C853.783,36.556,853.911,38.151,854.682,39.439C855.431,40.691,856.77,41.495,858.229,41.464"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float2"
          ></path>
          <path
            d="M877.5791424927039 30.68233238589687L882.643418738781 37.65271065126895 889.6137970041531 32.58843440519189 884.549520758076 25.618056139819817z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float3"
          ></path>
          <path
            d="M947.0863067780473 41.386781324995674L946.7054523964794 52.29302385948384 957.6116949309675 52.673878241051796 957.9925493125354 41.76763570656363z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float4"
          ></path>
          <path
            d="M1046.343828274252 43.440987996401745L1057.5390444642774 36.44544051125584 1050.5434969791313 25.25022432123056 1039.3482807891062 32.24577180637647z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float1"
          ></path>
          <path
            d="M1148.402661786797 59.33293108896859L1155.8870096239616 49.753402702367225 1146.3074812373602 42.2690548652025 1138.8231334001955 51.848583251803866z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float2"
          ></path>
          <path
            d="M1195.761,30.095C1197.614,30.01,1198.828,28.373,1199.738,26.756C1200.624,25.181,1201.305,23.345,1200.457,21.749C1199.567,20.075,1197.656,19.227,1195.761,19.277C1193.951,19.325,1192.399,20.428,1191.476,21.986C1190.534,23.578,1190.236,25.516,1191.1,27.152C1192.02,28.894,1193.793,30.185,1195.761,30.095"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float3"
          ></path>
          <path
            d="M1243.866,62.926C1249.121,63.155,1253.889,59.613,1256.2,54.888C1258.279,50.639,1256.652,45.846,1254.202,41.8C1251.863,37.936,1248.383,34.533,1243.866,34.517C1239.327,34.501,1235.583,37.744,1233.404,41.726C1231.318,45.538,1231.342,49.991,1233.265,53.887C1235.468,58.35,1238.894,62.709,1243.866,62.926"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float4"
          ></path>
        </g>
        <defs>
          <mask id="SvgjsMask2019">
            <rect width="1280" height="51" fill="#ffffff"></rect>
          </mask>
        </defs>
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:svgjs="http://svgjs.com/svgjs"
        width="1280"
        height="51"
        preserveAspectRatio="none"
        viewBox="0 0 1280 51"
        v-if="theme == 'dark' && false"
      >
        <g mask='url("#SvgjsMask2019")' fill="none">
          <rect width="1280" height="51" x="0" y="0" fill="transparent"></rect>
          <path
            d="M43.72089123433251 14.108722002328246L48.048891833273245 2.8338949700395304 36.774064800984526-1.4941056289012007 32.4460642020438 9.780721403387515z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float1"
          ></path>
          <path
            d="M47.903,38.405C49.476,38.403,50.737,37.221,51.473,35.831C52.158,34.536,52.19,32.986,51.434,31.731C50.701,30.515,49.323,29.89,47.903,29.907C46.514,29.924,45.234,30.625,44.515,31.813C43.769,33.046,43.654,34.56,44.313,35.842C45.033,37.244,46.327,38.407,47.903,38.405"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float2"
          ></path>
          <path
            d="M88.01686534738008 35.81093280829909L78.29044552151481 36.1505868730181 78.63009958623381 45.87700669888337 88.35651941209909 45.537352634164364z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float3"
          ></path>
          <path
            d="M156.308317967412 20.611882535611215L148.40566748430209 10.124711134924178 137.91849608361505 18.027361618034085 145.82114656672496 28.514533018721124z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float4"
          ></path>
          <path
            d="M175.426,65.876C180.921,65.887,185.986,62.659,188.497,57.771C190.822,53.245,189.365,48.051,186.857,43.624C184.303,39.114,180.603,34.938,175.426,34.693C169.878,34.43,164.677,37.605,161.949,42.443C159.267,47.2,159.72,52.986,162.443,57.72C165.174,62.469,169.948,65.865,175.426,65.876"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float2"
          ></path>
          <path
            d="M182.538,3.371C184.299,3.38,185.972,2.52,186.856,0.997C187.743,-0.531,187.589,-2.375,186.784,-3.948C185.889,-5.697,184.5,-7.332,182.538,-7.445C180.408,-7.568,178.307,-6.399,177.345,-4.494C176.454,-2.73,177.204,-0.695,178.293,0.954C179.254,2.41,180.793,3.362,182.538,3.371"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float2"
          ></path>
          <path
            d="M262.23160066908565 19.585956977587642L272.52803993410964 15.001686860261813 267.94376981678386 4.705247595237804 257.6473305517598 9.289517712563633z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float3"
          ></path>
          <path
            d="M345.027,65.088C349.672,64.706,352.483,60.328,354.517,56.134C356.247,52.568,356.457,48.619,354.753,45.04C352.735,40.802,349.713,36.483,345.027,36.208C339.992,35.913,335.64,39.411,333.105,43.772C330.555,48.159,329.907,53.527,332.384,57.955C334.916,62.481,339.858,65.513,345.027,65.088"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float4"
          ></path>
          <path
            d="M470.77343412819533 26.447287300053894L475.6113554608227 40.541250632445276 484.32743630945924 30.861062161686508z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float1"
          ></path>
          <path
            d="M557.196,47.644C558.557,47.593,559.823,46.941,560.515,45.768C561.219,44.575,561.29,43.087,560.589,41.893C559.896,40.712,558.565,40.113,557.196,40.115C555.83,40.117,554.551,40.748,553.816,41.9C553.018,43.15,552.668,44.754,553.42,46.032C554.164,47.296,555.73,47.698,557.196,47.644"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float2"
          ></path>
          <path
            d="M631.143,17.356C633.458,17.442,635.704,16.398,636.933,14.434C638.239,12.346,638.503,9.686,637.279,7.549C636.048,5.401,633.619,4.337,631.143,4.326C628.647,4.315,626.075,5.286,624.916,7.496C623.816,9.594,624.789,12.026,626.054,14.029C627.214,15.865,628.973,17.275,631.143,17.356"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float3"
          ></path>
          <path
            d="M678.7361791503604 8.410004518321873L688.2583155564213 11.688739020439455 691.5370500585389 2.16660261437854 682.014913652478-1.1121318877390411z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float4"
          ></path>
          <path
            d="M724.984,42.243C729.894,41.858,733.06,37.648,735.566,33.408C738.135,29.061,740.736,24.03,738.389,19.559C735.929,14.872,730.267,12.92,724.984,13.249C720.232,13.545,716.73,17.04,714.193,21.068C711.414,25.481,708.709,30.682,711.077,35.328C713.597,40.272,719.452,42.677,724.984,42.243"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float4"
          ></path>
          <path
            d="M858.229,41.464C859.639,41.434,860.848,40.531,861.527,39.295C862.181,38.106,862.139,36.699,861.51,35.497C860.826,34.19,859.703,33.044,858.229,32.99C856.676,32.933,855.255,33.879,854.506,35.241C853.783,36.556,853.911,38.151,854.682,39.439C855.431,40.691,856.77,41.495,858.229,41.464"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float2"
          ></path>
          <path
            d="M877.5791424927039 30.68233238589687L882.643418738781 37.65271065126895 889.6137970041531 32.58843440519189 884.549520758076 25.618056139819817z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float3"
          ></path>
          <path
            d="M947.0863067780473 41.386781324995674L946.7054523964794 52.29302385948384 957.6116949309675 52.673878241051796 957.9925493125354 41.76763570656363z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float4"
          ></path>
          <path
            d="M1046.343828274252 43.440987996401745L1057.5390444642774 36.44544051125584 1050.5434969791313 25.25022432123056 1039.3482807891062 32.24577180637647z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float1"
          ></path>
          <path
            d="M1148.402661786797 59.33293108896859L1155.8870096239616 49.753402702367225 1146.3074812373602 42.2690548652025 1138.8231334001955 51.848583251803866z"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float2"
          ></path>
          <path
            d="M1195.761,30.095C1197.614,30.01,1198.828,28.373,1199.738,26.756C1200.624,25.181,1201.305,23.345,1200.457,21.749C1199.567,20.075,1197.656,19.227,1195.761,19.277C1193.951,19.325,1192.399,20.428,1191.476,21.986C1190.534,23.578,1190.236,25.516,1191.1,27.152C1192.02,28.894,1193.793,30.185,1195.761,30.095"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float3"
          ></path>
          <path
            d="M1243.866,62.926C1249.121,63.155,1253.889,59.613,1256.2,54.888C1258.279,50.639,1256.652,45.846,1254.202,41.8C1251.863,37.936,1248.383,34.533,1243.866,34.517C1239.327,34.501,1235.583,37.744,1233.404,41.726C1231.318,45.538,1231.342,49.991,1233.265,53.887C1235.468,58.35,1238.894,62.709,1243.866,62.926"
            fill="rgba(28, 83, 142, 0.4)"
            class="triangle-float4"
          ></path>
        </g>
        <defs>
          <mask id="SvgjsMask2019">
            <rect width="1280" height="51" fill="#ffffff"></rect>
          </mask>
        </defs>
      </svg>

      <div class="header-index-wide">
        <div class="header-index-left" :style="topMenuStyle.headerIndexLeft">
          <logo class="top-nav-header" :show-title="device !== 'mobile'" :style="topMenuStyle.topNavHeader" />
          <div v-if="device !== 'mobile'" :style="topMenuStyle.topSmenuStyle">
            <s-menu mode="horizontal" :menu="menus" :theme="theme"></s-menu>
          </div>
          <a-icon v-else class="trigger" :type="collapsed ? 'menu-fold' : 'menu-unfold'" @click="toggle"></a-icon>
        </div>
        <user-menu class="header-index-right" :theme="theme" :style="topMenuStyle.headerIndexRight" />
      </div>
    </div>
  </a-layout-header>
</template>

<script>
import UserMenu from '../tools/UserMenu'
import SMenu from '../menu/'
import Logo from '../tools/Logo'

import { mixin } from '@/utils/mixin.js'

export default {
  name: 'GlobalHeader',
  components: {
    UserMenu,
    SMenu,
    Logo,
  },
  mixins: [mixin],
  props: {
    mode: {
      type: String,
      // sidemenu, topmenu
      default: 'sidemenu',
    },
    menus: {
      type: Array,
      required: true,
    },
    theme: {
      type: String,
      required: false,
      default: 'light',
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
    device: {
      type: String,
      required: false,
      default: 'desktop',
    },
  },
  data() {
    return {
      headerBarFixed: false,
      topMenuStyle: {
        headerIndexLeft: {},
        topNavHeader: {},
        headerIndexRight: {},
        topSmenuStyle: {},
      },
    }
  },
  watch: {
    /** 监听设备变化 */
    device() {
      if (this.mode === 'topmenu') {
        this.buildTopMenuStyle()
      }
    },
    /** 监听导航栏模式变化 */
    mode(newVal) {
      if (newVal === 'topmenu') {
        this.buildTopMenuStyle()
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    if (this.mode === 'topmenu') {
      this.buildTopMenuStyle()
    }
  },
  methods: {
    handleScroll() {
      if (this.autoHideHeader) {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 100) {
          this.headerBarFixed = true
        } else {
          this.headerBarFixed = false
        }
      } else {
        this.headerBarFixed = false
      }
    },
    toggle() {
      this.$emit('toggle')
    },
    buildTopMenuStyle() {
      if (this.mode === 'topmenu') {
        if (this.device === 'mobile') {
          // 手机端需要清空样式，否则显示会错乱
          this.topMenuStyle.topNavHeader = {}
          this.topMenuStyle.topSmenuStyle = {}
          this.topMenuStyle.headerIndexRight = {}
          this.topMenuStyle.headerIndexLeft = {}
        } else {
          let rightWidth = '250px'
          this.topMenuStyle.topNavHeader = { 'min-width': '200px' }
          this.topMenuStyle.topSmenuStyle = { width: 'calc(100% - 201px)', 'margin-left': '0px' }
          this.topMenuStyle.headerIndexRight = { 'min-width': rightWidth }
          this.topMenuStyle.headerIndexLeft = { width: `calc(100% - ${rightWidth})` }
        }
      }
    },
  },
}
</script>

<style>
@keyframes float1 {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(-20px, 0);
  }
  100% {
    transform: translate(0, 0);
  }
}

.triangle-float1 {
  animation: float1 4s infinite;
}

@keyframes float2 {
  0% {
    transform: translate(0, 0);
  }
  25% {
    transform: translate(-10px, -10px);
  }
  50% {
    transform: translate(-20px, 0px);
  }
  75% {
    transform: translate(-10px, 10px);
  }
  100% {
    transform: translate(0, 0);
  }
}

.triangle-float2 {
  animation: float2 12s infinite;
}

@keyframes float3 {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0px, -20px);
  }
  100% {
    transform: translate(0, 0);
  }
}

.triangle-float3 {
  animation: float3 6s infinite;
}

@keyframes float4 {
  0% {
    transform: translate(0, 0);
  }
  25% {
    transform: translate(10px, -10px);
  }
  50% {
    transform: translate(20px, 0px);
  }
  75% {
    transform: translate(10px, 10px);
  }
  100% {
    transform: translate(0, 0);
  }
}

.triangle-float4 {
  animation: float4 16s infinite;
}
</style>

<style lang="less" scoped>
@height: 51px;

svg {
  z-index: -1;
  position: absolute;
  background: transparent;
  padding-left: 140px;

  &:nth-child(2) {
    padding-left: 0px;
    left: 1280px;
  }

  path[fill='rgba(28, 83, 142, 0.4)'] {
    fill: var(--color-primary);
    opacity: 0.2;
  }
}

.layout {
  .top-nav-header-index {
    .header-index-wide {
      // margin-left: 10px;

      .ant-menu.ant-menu-horizontal {
        height: @height;
        line-height: @height;
      }
    }
    .trigger {
      &:hover {
        background: rgba(0, 0, 0, 0.05);
      }
    }
  }

  .header {
    z-index: 2;
    color: white;
    height: @height;
    transition: background 300ms;

    /* dark 样式 */
    &.dark {
      color: #000000;
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
      background-color: white !important;
    }

    .anticon-menu-fold,
    .anticon-menu-unfold {
      height: 100%;
      margin-top: 0px;
      padding-top: 3px;
      line-height: @height;
    }

    .ant-avatar-image {
      margin: 17px 10px 20px 0;
    }
  }

  .header,
  .top-nav-header-index {
    &.dark .trigger:hover {
      background: rgba(0, 0, 0, 0.05);
    }
  }
}

.ant-layout-header {
  height: @height;
  line-height: @height;
}
</style>